import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=29067c83&scoped=true&"
import script from "./DocumentEdit.vue?vue&type=script&lang=ts&"
export * from "./DocumentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEdit.vue?vue&type=style&index=0&id=29067c83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29067c83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VDivider,VRow,VTextarea})
